import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import { TextLink } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const MenuMoreInfoContactUs = (props: MenuMoreInfoContactUsProps) => {
  const { onPress } = props;

  return (
    <TextLink sizeMatch={['16']} onPress={onPress}>
      <FormattedMessage {...messages.contactUs} />
    </TextLink>
  );
};

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  contactUs: {
    defaultMessage: 'Contact Us',
    description: 'Menu | More info | Contact us',
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type MenuMoreInfoContactUsProps = {
  onPress: () => void;
};
